{
  "name": "Goliath",
  "version": "1.13.2",
  "scripts": {
    "ng": "ng",
    "reset": "nx reset",
    "build:public-pages": "node tools/build-public-pages.mjs",
    "watch:public-pages": "node tools/build-public-pages.mjs --watch",
    "start:angular": "nx serve",
    "start": "cross-env NODE_OPTIONS=--max-old-space-size=2048 node tools/start-dev-with-public-pages.mjs",
    "start:second": "cross-env NODE_OPTIONS=--max-old-space-size=2048 node tools/start-dev-with-public-pages.mjs --configuration=second",
    "clean-build": "rimraf dist && yarn build:prod",
    "build": "nx build",
    "build:prod": "nx build --configuration production",
    "build:docker": "nx build --configuration docker --skip-nx-cache",
    "build-start": "yarn build && yarn start",
    "watch": "nx build --watch --configuration local",
    "test": "nx test",
    "lint": "nx lint",
    "proxy": "run-scripts proxy-odyssey proxy-odyssey-file-management proxy-local proxy-contacts proxy-documents proxy-goliath-core proxy-products proxy-shaping",
    "proxy-local": "nx g @abp/nx.generators:generate-proxy --entryPoint src/app/proxy --apiName default --serviceType application --source Goliath",
    "proxy-goliath-core": "nx g @abp/nx.generators:generate-proxy --module goliath-core --target goliath-core --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-contacts": "nx g @abp/nx.generators:generate-proxy --module goliath-contacts --target goliath-contacts --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-documents": "nx g @abp/nx.generators:generate-proxy --module goliath-documents --target goliath-documents --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-products": "nx g @abp/nx.generators:generate-proxy --module goliath-products --target goliath-products --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-shaping": "nx g @abp/nx.generators:generate-proxy --module shaping-management --target goliath-shaping-management --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-odyssey": "nx g @abp/nx.generators:generate-proxy --module core --target @digiwall/core --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy-odyssey-file-management": "nx g @abp/nx.generators:generate-proxy --module file-management --target @digiwall/file-management --entryPoint proxy --apiName default --serviceType application --source Goliath",
    "proxy:second": "run-scripts proxy-odyssey:second proxy-odyssey-file-management:second proxy-local:second proxy-contacts:second proxy-documents:second proxy-goliath-core:second proxy-products:second proxy-shaping:second",
    "proxy-local:second": "nx g @abp/nx.generators:generate-proxy --entryPoint src/app/proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-goliath-core:second": "nx g @abp/nx.generators:generate-proxy --module goliath-core --target goliath-core --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-contacts:second": "nx g @abp/nx.generators:generate-proxy --module goliath-contacts --target goliath-contacts --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-documents:second": "nx g @abp/nx.generators:generate-proxy --module goliath-documents --target goliath-documents --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-products:second": "nx g @abp/nx.generators:generate-proxy --module goliath-products --target goliath-products --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-shaping:second": "nx g @abp/nx.generators:generate-proxy --module shaping-management --target goliath-shaping-management --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-odyssey:second": "nx g @abp/nx.generators:generate-proxy --module core --target @digiwall/core --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350",
    "proxy-odyssey-file-management:second": "nx g @abp/nx.generators:generate-proxy --module file-management --target @digiwall/file-management --entryPoint proxy --apiName default --serviceType application --source Goliath --url https://localhost:44350"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "private": true,
  "dependencies": {
    "@abp/ng.account": "9.2.1",
    "@abp/ng.components": "9.2.1",
    "@abp/ng.core": "9.2.1",
    "@abp/ng.identity": "9.2.1",
    "@abp/ng.oauth": "9.2.1",
    "@abp/ng.setting-management": "9.2.1",
    "@abp/ng.tenant-management": "9.2.1",
    "@abp/ng.theme.lepton-x": "~4.1.0",
    "@abp/ng.theme.shared": "9.2.1",
    "@abp/nx.generators": "9.2.1",
    "@ag-grid-community/angular": "^32.3.7",
    "@ag-grid-community/client-side-row-model": "^32.3.7",
    "@ag-grid-community/core": "^32.3.7",
    "@ag-grid-community/locale": "^32.0.0",
    "@ag-grid-community/styles": "^32.3.7",
    "@ag-grid-enterprise/advanced-filter": "^32.3.7",
    "@ag-grid-enterprise/clipboard": "^32.3.7",
    "@ag-grid-enterprise/column-tool-panel": "^32.3.7",
    "@ag-grid-enterprise/excel-export": "^32.3.7",
    "@ag-grid-enterprise/filter-tool-panel": "^32.3.7",
    "@ag-grid-enterprise/menu": "^32.3.7",
    "@ag-grid-enterprise/multi-filter": "^32.3.7",
    "@ag-grid-enterprise/range-selection": "^32.3.7",
    "@ag-grid-enterprise/rich-select": "^32.3.7",
    "@ag-grid-enterprise/server-side-row-model": "^32.3.7",
    "@ag-grid-enterprise/set-filter": "^32.3.7",
    "@ag-grid-enterprise/side-bar": "^32.3.7",
    "@angular/animations": "19.2.10",
    "@angular/common": "19.2.10",
    "@angular/compiler": "19.2.10",
    "@angular/core": "19.2.10",
    "@angular/forms": "19.2.10",
    "@angular/google-maps": "19.2.15",
    "@angular/localize": "19.2.10",
    "@angular/platform-browser": "19.2.10",
    "@angular/platform-browser-dynamic": "19.2.10",
    "@angular/router": "19.2.10",
    "@angular/service-worker": "19.2.10",
    "@cluetec/ngcx-tree": "19.2.2",
    "@devexpress/analytics-core": "^24.2.5",
    "@microsoft/signalr": "^8.0.0",
    "@ng-select/ng-option-highlight": "^14.2.3",
    "@ng-select/ng-select": "^14.2.3",
    "@ngrx/signals": "^17.0.1",
    "@popperjs/core": "^2.11.8",
    "@types/google.maps": "^3.54.10",
    "@volo/abp.ng.language-management": "9.2.1",
    "angularx-qrcode": "^21.0.5",
    "bootstrap": "^5.3.2",
    "bootstrap-icons": "~1.8.3",
    "dayjs": "^1.11.11",
    "dequal": "^2.0.3",
    "devexpress-reporting-angular": "^24.2.5",
    "devextreme": "^24.2.5",
    "devextreme-angular": "^24.2.5",
    "fuse.js": "^7.1.0",
    "glob": "^13.0.1",
    "i": "^0.3.7",
    "intl-tel-input": "19.2.16",
    "lint-staged": "^16.2.7",
    "liquidjs": "^10.10.1",
    "moment": "^2.30.1",
    "ng2-pdfjs-viewer": "^19.0.0",
    "ngx-daterangepicker-material": "^6.0.4",
    "ngx-editor": "^17.0.1",
    "ngx-json-viewer": "^3.2.1",
    "ngx-mask": "^17.1.8",
    "ngx-tagify": "^18.0.0",
    "npm": "^10.7.0",
    "pretty-bytes": "^7.1.0",
    "prosemirror-autocomplete": "^0.4.3",
    "rxjs": "~7.8.2",
    "ts-toolbelt": "8.4.0",
    "tslib": "^2.1.0",
    "viewerjs": "^1.11.6",
    "xlsx": "^0.18.5",
    "xng-breadcrumb": "^13.0.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@abp/ng.schematics": "9.2.1",
    "@angular-devkit/build-angular": "19.2.10",
    "@angular-devkit/core": "19.2.10",
    "@angular-devkit/schematics": "19.2.10",
    "@angular-eslint/builder": "~19.3.0",
    "@angular-eslint/eslint-plugin": "~19.3.0",
    "@angular-eslint/eslint-plugin-template": "~19.3.0",
    "@angular-eslint/schematics": "~19.3.0",
    "@angular-eslint/template-parser": "~19.3.0",
    "@angular/cli": "19.2.10",
    "@angular/compiler-cli": "19.2.10",
    "@angular/language-service": "19.2.10",
    "@nx/angular": "21.0.0",
    "@nx/eslint": "21.0.0",
    "@nx/eslint-plugin": "21.0.0",
    "@nx/jest": "21.0.0",
    "@nx/js": "21.0.0",
    "@nx/workspace": "21.0.0",
    "@schematics/angular": "19.2.10",
    "@types/jasmine": "~3.6.0",
    "@types/jest": "29.5.14",
    "@types/node": "^20.14.12",
    "@typescript-eslint/eslint-plugin": "^7.11.0",
    "@typescript-eslint/parser": "^7.11.0",
    "cross-env": "^10.1.0",
    "eslint": "^8.53.0",
    "jasmine-core": "~4.0.0",
    "karma": "~6.3.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.7.0",
    "ng-packagr": "^19.2.2",
    "nx": "^21.1.2",
    "prettier": "3.3.3",
    "run-scripts": "^0.4.0",
    "signature_pad": "^5.1.3",
    "typescript": "~5.5.0"
  },
  "resolutions": {
    "angular-oauth2-oidc": "~19.0.0"
  },
  "nx": {},
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
